import { Action } from '@ngrx/store';
import { IAgencyModel } from '../../models/account/IAgency.model';

export const GET_AGENCY = '[Agency] Get Agency';
export const GET_AGENCY_SUCCESS = '[Agency] Get Agency Success';
export const GET_AGENCY_ERROR = '[Agency] Get Agency Error';

// Actions for Getting Agency
export class GetAgency implements Action {
  readonly type = GET_AGENCY;
}

export class GetAgencySuccess implements Action {
  readonly type = GET_AGENCY_SUCCESS;

  constructor(public payload: IAgencyModel) {}
}

export class GetAgencyError implements Action {
  readonly type = GET_AGENCY_ERROR;
}

export type AgencyActions = GetAgency | GetAgencySuccess | GetAgencyError;
